module.exports = __webpack_public_path__ + "img/ifmcs-app.c2ba7788.png";